import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useUiComponentsInternationalContext } from '@repo/static-translations';

import sharedStyles from '../styles';
import NavigateButton from './NavigateButton';

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid ${({ theme }) => theme.colors.border};
  padding: ${sharedStyles.spacing['spacing-lg']};
  margin-top: ${sharedStyles.spacing['spacing-md']};

  > a {
    margin: 0 ${sharedStyles.spacing['spacing-sm']};

    &:hover {
      text-decoration: none;
    }
  }
`;

function PaginationArea({ previousPagePath, nextPagePath }) {
  const { tt } = useUiComponentsInternationalContext();

  return (
    <Container>
      {previousPagePath && (
        <NavigateButton
          aria-label={tt(s => s.paginationCommon.previousAriaLabel)}
          to={previousPagePath}
        >
          <span aria-hidden="true">&lt;</span>{' '}
          {tt(s => s.paginationCommon.prevButton)}
        </NavigateButton>
      )}
      {nextPagePath && (
        <NavigateButton
          aria-label={tt(s => s.paginationCommon.nextAriaLabel)}
          to={nextPagePath}
        >
          {tt(s => s.paginationCommon.nextButton)}{' '}
          <span aria-hidden="true">&gt;</span>
        </NavigateButton>
      )}
    </Container>
  );
}

PaginationArea.propTypes = {
  previousPagePath: PropTypes.string,
  nextPagePath: PropTypes.string,
};

PaginationArea.defaultProps = {
  previousPagePath: null,
  nextPagePath: null,
};

export default PaginationArea;
